var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeForthBox2Icon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_112546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.06325 6.74461C8.25115 6.37635 8.62966 6.14453 9.04309 6.14453H45.41C45.8235 6.14453 46.202 6.37635 46.3899 6.74461L51.5684 16.8946C51.7551 17.2605 51.4893 17.6945 51.0785 17.6945H3.37462C2.96381 17.6945 2.698 17.2605 2.8847 16.8946L8.06325 6.74461Z",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1273 17.6943C15.1273 21.0357 12.4187 23.7443 9.07734 23.7443C5.73602 23.7443 3.02734 21.0357 3.02734 17.6943",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225 17.6953C27.225 21.0366 24.5163 23.7453 21.175 23.7453C17.8337 23.7453 15.125 21.0366 15.125 17.6953",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3266 17.6943C39.3266 21.0357 36.6179 23.7443 33.2766 23.7443C29.9352 23.7443 27.2266 21.0357 27.2266 17.6943",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4281 17.6953C51.4281 21.0366 48.7194 23.7453 45.3781 23.7453C42.0368 23.7453 39.3281 21.0366 39.3281 17.6953",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 23.7441V45.1941",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.8281,
    y: 28.6943,
    width: 15.95,
    height: 11,
    rx: 1.1,
    stroke: "#00805B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0781 28.6943V39.6943",
    stroke: "#00805B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.625 32.636L42.625 29.7943C42.625 29.1868 42.1325 28.6943 41.525 28.6943L33.825 28.6943C33.2175 28.6943 32.725 29.1868 32.725 29.7943L32.725 44.6443",
    stroke: "#00805B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8358 45.1943H4.12734C3.51983 45.1943 3.02734 45.6868 3.02734 46.2943V48.4943C3.02734 49.1018 3.51983 49.5943 4.12734 49.5943H34.8358",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8159 32.428L40.3272 46.5889C40.1578 46.873 40.0458 47.384 40.0737 47.7146L40.3184 50.0849C40.4093 50.9403 41.1344 51.3793 41.9309 51.0544L44.1425 50.1563C44.451 50.0285 44.8488 49.6941 45.0167 49.4028L53.5053 35.2419C54.2832 33.9484 54.4714 32.6276 52.566 31.4831C50.6709 30.3513 49.5938 31.1345 48.8159 32.428Z",
    stroke: "#202020",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4805 35.0625C48.2208 36.9647 49.806 38.0823 51.8339 37.8456",
    stroke: "#202020",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_112546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(0 0.0947266)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeForthBox2Icon1);
export default __webpack_public_path__ + "static/media/home-forth-box2-icon1.fc6482f5eb6ba7a7744128d8f00e5ed6.svg";
export { ForwardRef as ReactComponent };